import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/custom/pip.svg?react
const SvgPip = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	fill: "none",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	fill: "currentColor",
	d: "M80-520v-80h144L52-772l56-56 172 172v-144h80v280zm80 360q-33 0-56.5-23.5T80-240v-200h80v200h320v80zm640-280v-280H440v-80h360q33 0 56.5 23.5T880-720v280zM560-160v-200h320v200z"
}));

//#endregion
//#region src/icons/PipIcon.tsx
function PipIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgPip,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { PipIcon as t };
//# sourceMappingURL=PipIcon-BGbWgttv.js.map